import { ReactRouter } from "@atlassiansox/microscopekit";
export var useQueryParams = function () {
    return new URLSearchParams(ReactRouter.useLocation().search);
};
